var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCyanCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#97FFFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13L24 20.5172L37 13L33.1297 20.5114L28.5599 23.154L24 25.7907L19.4401 23.154L14.8703 20.5114L11 13ZM20.6513 27.727L24 29.6634L27.3487 27.727L30.2878 26.0271L28.9381 28.6458L27.4014 31.6294L24 38.2312L20.5986 31.6294L19.061 28.6458L17.7122 26.0271L20.6513 27.727Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCyanCircle);
export default __webpack_public_path__ + "static/media/logo-cyan-circle.cdc2a680d3c20faefd69b297d7e9ca95.svg";
export { ForwardRef as ReactComponent };